import Box from '@mui/joy/Box'
import CssBaseline from '@mui/joy/CssBaseline'
import Typography from '@mui/joy/Typography'
import { CssVarsProvider } from '@mui/joy/styles'
import { Children } from 'types'
import ColorSchemeToggle from '../../../../components/ColorSchemeToggle'

export const AuthLayout = ({ children }: Children) => {
    return (
        <CssVarsProvider defaultMode="dark" disableTransitionOnChange>
            <CssBaseline />
            <Box sx={{ height: '100vh' }}>
                <Box
                    sx={{
                        height: '100vh', // Full height
                        display: 'flex',
                        justifyContent: 'center', // Center horizontally
                        alignItems: 'center', // Center vertically
                        position: 'relative',
                        overflow: 'hidden', // Ensure no overflow
                    }}
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundImage: `url('/background.webp')`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            filter: 'blur(8px)', // Apply blur to the entire image
                            zIndex: -1, // Send the background behind other elements
                        }}
                    />
                    <Box
                        key={'auth-element'}
                        sx={{
                            width: '35rem',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            padding: 2,
                            backdropFilter: 'blur(8px)', // Optional: Add a backdrop blur to UI elements
                            backgroundColor: 'rgba(255, 255, 255, 0.4)', // Semi-transparent background for UI elements
                            borderRadius: '24px', // Rounded corners
                            boxShadow: '0 12px 60px rgba(0, 0, 0, 0.2)', // Increased shadow for diffused edges
                            position: 'relative',
                            overflow: 'hidden', // Ensure overflow is hidden
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 80%)', // Gradient for diffused edges
                                borderRadius: '24px', // Match border radius
                            }}
                        />
                        <Box component="header" sx={{ py: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography sx={{ pr: 2 }} fontWeight="lg" startDecorator={<img alt="logo" src="/favicon.png" width="28" height="28" />}>
                                Numeo.AI
                            </Typography>
                            <ColorSchemeToggle />
                        </Box>
                        {children}
                        <Box component="footer" sx={{ py: 3, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography level="body-xs" textAlign="center">
                                Numeo {new Date().getFullYear()}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </CssVarsProvider>
    )
}
